var axios = require('axios')
const url = process.env.version + '/product-payment-fe'
const urlPayment = process.env.version + '/product-payment-fe/payment'

axios.getPaymentStatus = function (transaction, success, callBackError) {
  this.get(urlPayment + '/' + transaction)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.trackerPaymentStatus = function (transaction, success, callBackError) {
  axios.options.flag = false
  this.get(urlPayment + '/' + transaction)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getpaymentMethod = function (success, callBackError) {
  this.get(url + '/payment-methods')
    .then(reponse => {
      success(reponse)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCybersourcePaymentPayload = function (uuid, success, callBackError) {
  const url = urlPayment + '/cybersourcemy/payment-payload?transaction=' + uuid
  this.get(url).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === false) {
      if (typeof callBackError !== 'undefined') {
        return callBackError(error.response.data)
      }
    }
    return callBackError(error)
  })
}

axios.makeCreditPayment = function (data, success, callBackError) {
  this.post(urlPayment + '/softbankjp/credit-payment', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.removeSavedCard = function (uuid, success, callBackError) {
  axios.options.flag = true
  axios.options.notify = true
  this.delete(urlPayment + `/saved-card/${uuid}`).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
export default axios



// WEBPACK FOOTER //
// ./src/api/Payment.js